export const initClinicCaseRoutes = (config: any, enabled: boolean = true) =>
  !enabled
    ? []
    : [
        {
          path: "/manage/clinic-cases",
          name: "clinic-case",
          component: () => import("@/pages/manage/clinic-cases/index.vue"),
          meta: {
            requiresAuth: true,
            roles: [config.roles.administrators, config.roles.siteEditors],
          },
        },
        {
          path: "/manage/clinic-cases/:id",
          name: "clinic-case-id",
          component: () => import("@/pages/manage/clinic-cases/id.vue"),
          meta: {
            requiresAuth: true,
            roles: [config.roles.administrators, config.roles.siteEditors],
          },
        },
      ];
